import * as L from 'leaflet';
import { FreerideLines } from './FreerideLines';
import { Pois } from './FreeridePois';
import { FreeridePolys } from './FreeridePolys';
// import * as togpx from 'togpx';

const EditLayer = L.FeatureGroup.extend({
  onAdd: async function (map) {
    const pois = new Pois(map, this);
    pois.loadPois();
    const lines = new FreerideLines(map, this);
    lines.loadLines({ showExport: true });
    const polys = new FreeridePolys(map, this);
    polys.loadPolys();
    map.on("moveend", () => {
      pois.loadPois();
    })
  },
});

export default EditLayer;

